module.exports = __webpack_public_path__ + "static/media/img-destaque-internas.8af054b2.jpg";